export default __webpack_public_path__ + "static/media/Calendar.6fcb8b4b.svg";